<template>
  <div id="bhagavad-gita-40-most-important-verses">
    <v-carousel
      :cycle="false"
      hide-delimiter-background
      show-arrows-on-hover
      @change="monitorSlideChange($event)"
      style="height: fit-content"
    >
      <div
        class="slide"
        v-for="(slide, i) in verses"
        :key="i"
      >
        <audio
          :src="checkAndPlay(slide,i)"
          :ref="generateName(i)"
          controls
        ></audio>
        <v-carousel-item>
          <v-sheet
            :color="colors[i]"
            height="100%"
          >
            <div class="sloka-sanskrit">
              <h3> {{slide.slokaId}} </h3>
              <a
                :href="language === 'pt' ? slide.slokaLinkPt : slide.slokaLinkEn"
                target="_blank"
              >
                <span
                  style="color: unset;"
                  v-html="slide.sanskrit"
                ></span>
                <br>
                <span
                  style="color: unset;"
                  v-html="language === 'pt' ? clickToOpenPt : clickToOpenEn"
                ></span>
              </a>
              <br>
            </div>
            <v-row
              justify="center"
              style="margin: 0"
            >
              <div class="slide-translation">
                {{language === 'pt' ? slide.translationPt : slide.translationEn}}
              </div>
            </v-row>
          </v-sheet>
        </v-carousel-item>
      </div>
    </v-carousel>
  </div>
</template>

<script>
import { eventBus } from "../main.js"
import mixins from "../assets/mixins.js"
export default {
  name: "BG40",
  mixins: [mixins],

  mounted() {
    eventBus.$on("updateLanguage", this.setLang)
  },

  data() {
    return {
      colors: [
        "indigo",
        "warning",
        "pink darken-2",
        "red lighten-1",
        "deep-purple accent-4"
      ],
      clickToOpenPt: "<small> Clique no sânscrito para abrir o link </small>",
      clickToOpenEn:
        "<small> Click the sanskrit-verse to open the link </small>",
      verses: [
        {
          slokaId: "Bg.2.13",
          slokaLink: `https://vedabase.io/${this.language === 'pt' ? 'pt-br' : 'en'}/library/bg/2/13/`,
          sanskrit:
            "<em> dehino ’smin yathā dehe <br> kaumāraṁ yauvanaṁ jarā <br> tathā dehāntara-prāptir <br> dhīras tatra na muhyati </em>",
          // sanskritAudio: "audio/bhagavad_gita/bg-3-32-sanskrit.m4a",
          translationPt:
            "Assim como a alma encarnada passa seguidamente, neste corpo, da infância à juventude e à velhice, da mesma maneira, a alma passa para um outro corpo após a morte. Uma pessoa sóbria não se confunde com tal mudançaAssim como a alma encarnada passa seguidamente, neste corpo, da infância à juventude e à velhice, da mesma maneira, a alma passa para um outro corpo após a morte. Uma pessoa sóbria não se confunde com tal mudança",
          // ptAudio: "audio/bhagavad_gita/bg-3-32-pt.m4a",
          translationEn:
            "As the embodied soul continuously passes, in this body, from boyhood to youth to old age, the soul similarly passes into another body at death. A sober person is not bewildered by such a change",
          // enAudio: "audio/bhagavad_gita/bg-3-32-en.m4a"
        },
        {
          slokaId: "Bg.3.32",
          slokaLink: "https://vedabase.io/pt-br/library/bg/3/32/",
          sanskrit:
            "<em> ye tv etad abhyasūyanto <br> nānutiṣṭhanti me matam <br> sarva-jñāna-vimūḍhāṁs tān <br> viddhi naṣṭān acetasaḥ </em>",
          sanskritAudio: "audio/bhagavad_gita/bg-3-32-sanskrit.m4a",
          translationPt:
            "Mas aqueles que, por inveja, rejeitam e não seguem estes ensinamentos devem ser considerados desprovidos de todo o conhecimento, enganados e arruinados nos seus esforços para a perfeição",
          ptAudio: "audio/bhagavad_gita/bg-3-32-pt.m4a",
          translationEn:
            "But those who, out of envy, disregard these teachings and do not follow them regularly are to be considered bereft of all knowledge, befooled, and ruined in their endeavors for perfection.",
          enAudio: "audio/bhagavad_gita/bg-3-32-en.m4a"
        },
        {
          slokaId: "Bg.4.40",
          slokaLinkPt: "https://vedabase.io/pt-br/library/bg/4/40/",
          slokaLinkEn: "https://vedabase.io/en/library/bg/4/40/",
          sanskrit:
            "<em> ajñaś cāśraddadhānaś ca <br> saṁśayātmā vinaśyati <br> nāyaṁ loko ’sti na paro <br> na sukhaṁ saṁśayātmanaḥ </em>",
          sanskritAudio: "audio/bhagavad_gita/bg-4-40-sanskrit.m4a",
          translationPt:
            "Mas as pessoas ignorantes e sem fé, que duvidam das escrituras reveladas, não alcançam a consciência de Deus; elas acabam caindo. Para a alma em dúvida não há felicidade nem neste mundo nem no próximo",
          ptAudio: "audio/bhagavad_gita/bg-4-40-pt.m4a",
          translationEn:
            "But ignorant and faithless persons who doubt the revealed scriptures do not attain God consciousness; they fall down. For the doubting soul there is happiness neither in this world nor in the next",
          enAudio: "audio/bhagavad_gita/bg-4-40-en.m4a"
        }
      ],
      lang: null,
      windowWidth: window.innerWidth
    }
  },
  methods: {
    monitorSlideChange(index) {
      // console.log(index)

      for (let ref in this.$refs) {
        if (this.$refs[ref] && this.$refs[ref][0].localName === "audio") {
          this.$refs[ref][0].pause()
        }
      }

      const el = this.$refs[`audio${index}`][0]
      if (el) {
        el.onended = () => {
          if (el.src.indexOf("sanskrit") > -1) {
            if (this.language === "pt") {
              if (this.verses[index].ptAudio) {
                el.src = this.verses[index].ptAudio
                el.oncanplaythrough = () => el.play()
              }
            } else {
              if (this.verses[index].enAudio) {
                el.src = this.verses[index].enAudio
                el.oncanplaythrough = () => el.play()
              }
            }
          } else {
            el.src = null
          }
        }

        if (!el.src) {
          el.src = this.verses[index].sanskritAudio
          el.oncanplaythrough = () => el.play()
        } else {
          if (el.readyState === 4) {
            el.play()
          } else {
            el.oncanplaythrough = () => {
              el.play()
            }
          }
        }
      }
    },

    generateName(index) {
      // if (index === 0) {
      //   setTimeout(() => {
      //
      //     this.$refs.audio0[0].oncanplay = () => {

      //       // this.$refs.audio0[0].onended = () => {

      //       // }

      //       this.$refs.audio0[0].play()
      //     }
      //   }, 1500);
      // }

      return `audio${index}`
    },

    checkAndPlay(slide) {
      if (slide.sanskritAudio) {
        return slide.sanskritAudio

        // if (this.language === 'pt') {

        // } else {

        // }
      }
    }
  }
}
</script>

<style>
.sloka-sanskrit {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.v-sheet {
  min-width: 250px;
}

.slide-translation {
  font-size: 2rem;
  font-weight: 300;
  line-height: 2.5rem;
  letter-spacing: 0.0073529412em !important;
  font-family: "Roboto", sans-serif !important;
  padding: 3%;
}

@media screen and (max-width: 550px) {
  .slide-translation {
    font-size: 1.5rem;
  }
}
</style>